import { useRef } from "react";
import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";

export default function FileBait(props) {
    const { children, disabled, onFile } = props;

    const ref = useRef<HTMLInputElement>();

    function onClick() {
        ref.current?.click?.();
    }

    function onChange(event) {
        const [file] = event.target.files;
        onFile(file);
    }

    return (
        <Styled>
            <input
                disabled={ disabled }
                onChange={ onChange }
                ref={ ref }
                type="file"
            />
            <UI.Button
                disabled={ disabled }
                onClick={ onClick }
            >
                Select file from your computer
            </UI.Button>
            { children }
        </Styled>
    );
}

const Styled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;

    input {
        display: none;
    }
`;
